<template>
  <span>
    <label class="page-label">{{
      $t('message.pages.live.recordingDestination')
    }}</label>
    <p style="font-weight: 400px; font-size: 14px; line-height: 21px">
      {{ $t('message.pages.live.recordingDestinationDescription') }}
    </p>

    <div class="d-flex align-center">
      <base-btn
        v-if="folder.folder_id"
        class="px-0 no-hover"
        type="tertiary"
        @click="openModal"
      >
        <v-icon color="primary" class="mr-2">mdi-folder</v-icon>
      </base-btn>

      <base-btn v-else class="px-0 no-hover" type="tertiary" @click="openModal">
        <v-icon color="primary" class="mr-2">mdi-folder</v-icon>
      </base-btn>

      <span class="folderPath" style="color: var(--v-brand-base)">
        {{ getFolderPath() }}
      </span>
    </div>

    <aside>
      <LiveFolderModal :props-data="propsData" />
    </aside>
  </span>
</template>

<script>
// external imports
import { mapState } from 'vuex'

// API

// Components
import BaseBtn from '@/components/BaseBtn.vue'

export default {
  name: 'LiveFolder',
  components: {
    BaseBtn,
    LiveFolderModal: () => import('./LiveFolderModal.vue'),
  },
  props: {
    propsData: {
      type: Object,
      required: true,
    },
    folderId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('user', {
      folders: 'mainFolders',
    }),
    folder: {
      get() {
        return this.propsData['folder']
      },
      set(value) {
        this.propsData['folder'] = value
      },
    },
  },
  methods: {
    openModal() {
      this.$root.$emit('openLiveFolderModal')
    },

    findFolderById(id) {
      return this.folders.find((folder) => folder.id === id)
    },
    getFolderPath() {
      let theFolder = this.findFolderById(this.folderId)
      let folderArray = [theFolder]
      let searchMoreFolders = true

      do {
        let folder = folderArray[folderArray.length - 1]
        if (folder.parent_folder_id) {
          let parentFolderId = folder.parent_folder_id
          let parentFolder = this.findFolderById(parentFolderId)
          folderArray.push(parentFolder)
        } else {
          searchMoreFolders = false
        }
      } while (searchMoreFolders)

      folderArray = folderArray.map((folder) => folder.name)
      folderArray.push('')
      folderArray = folderArray.reverse()
      let folderPathString = folderArray.join('/')

      return folderPathString
    },
  },
}
</script>

<style lang="scss" scoped>
.no-hover {
  &:hover {
    $color: rgba(#fff, 0);

    border-color: $color;
    background-color: $color;
  }
}

::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }
}
</style>
